import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  styled,
  Typography,
} from '@mui/material';
import { themeShape } from '@peritasai/ui-shared';
import React from 'react';
import {
  DialogCloseButton,
  WarningIcon,
  WarningIconAvatar,
  WarningIconContainer,
} from './dialogShared';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: themeShape.borderRadius.extraLarge,
    maxWidth: '644px',
    width: '100%',
  },
}));

export interface LeaveSessionDialogProps {
  open: boolean;
  isLeaving?: boolean;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export const LeaveSessionDialog: React.FC<LeaveSessionDialogProps> = ({
  open,
  isLeaving = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <StyledDialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          padding: '1.5rem 1.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid rgba(0,0,0,0.12)',
        }}
      >
        <WarningIconContainer>
          <WarningIconAvatar>
            <WarningIcon />
          </WarningIconAvatar>
          <Typography
            variant="h6"
            component="span"
            sx={{ pl: 1, fontWeight: 700 }}
          >
            Leave Session?
          </Typography>
        </WarningIconContainer>
        <DialogCloseButton onClick={onCancel} />
      </DialogTitle>
      <DialogContent
        sx={{
          padding: 0,
          minHeight: '4rem',
        }}
      >
        <Typography
          variant="body1"
          sx={{ padding: '1.5rem 1.5rem', color: 'text.secondary' }}
        >
          Your changes have been saved.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          sx={{ textTransform: 'none' }}
          onClick={onCancel}
          disabled={isLeaving}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{ textTransform: 'none' }}
          color="primary"
          onClick={onConfirm}
          disabled={isLeaving}
        >
          Leave Session
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};
